// 3rd Party
import React from 'react';

// Component
const VerifyPhoneAndEmailOneSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="105"
    height="40"
    role="presentation"
  >
    <defs>
      <linearGradient id="a" x1="14.497%" x2="87.348%" y1="0%" y2="0%">
        <stop offset="0%" stopColor="#F37F6E" />
        <stop offset="100%" stopColor="#F3F1F3" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#a)" fillRule="nonzero" d="M72 19v3H34v-3z" />
      <rect width="40" height="40" fill="#F37F6E" rx="20" />
      <rect width="40" height="40" x="65" fill="#F3F1F3" rx="20" />
      <path
        fill="#D0CDD0"
        fillRule="nonzero"
        d="M76.136 13c-.618 0-1.136.518-1.136 1.136v10.91c0 .617.518 1.136 1.136 1.136h17.728A1.15 1.15 0 0095 25.045V14.136c0-.618-.518-1.136-1.136-1.136H76.136zm1.307 1.364h15.114l-7.316 6.534c-.1.089-.383.089-.483 0l-7.315-6.534zm-1.08.859l5.107 4.567-5.106 4.226v-8.793zm17.273 0v8.793L88.53 19.79l5.106-4.567zM82.5 20.706l1.35 1.207a1.714 1.714 0 002.3 0l1.35-1.207 4.972 4.112H77.528l4.972-4.112z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M25.385 11h-11.06A4.334 4.334 0 0010 15.324v4.191a4.334 4.334 0 004.324 4.325h4.396c.089.03.485.353.928.81 1.43 1.387 3.662 4.032 6.736 4.081a.764.764 0 00.646-1.17c-.946-1.498-1.143-2.563-1.145-3.224 0-.241.029-.414.06-.553 2.117-.28 3.763-2.076 3.765-4.269v-4.19A4.334 4.334 0 0025.384 11zm2.797 8.516a2.817 2.817 0 01-2.798 2.799.764.764 0 00-.65.361c-.06.094-.377.664-.377 1.662-.001.671.166 1.537.602 2.552-.994-.394-1.967-1.115-2.824-1.923-.632-.591-1.196-1.193-1.693-1.674a6.7 6.7 0 00-.723-.625c-.246-.164-.494-.338-.924-.352h-4.47a2.818 2.818 0 01-2.8-2.799l.002-4.191a2.818 2.818 0 012.798-2.799h11.06a2.818 2.818 0 012.799 2.799v4.19h-.002z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M24.944 14.94H14.767a.764.764 0 000 1.528h10.177a.764.764 0 000-1.527zm0 3.434H14.767a.764.764 0 000 1.527h10.177a.764.764 0 000-1.527z"
      />
    </g>
  </svg>
);

export default VerifyPhoneAndEmailOneSvg;
